const heroesElement = document.querySelector('.Heroes')

if (heroesElement) {
  setTimeout(function () {
    heroesElement.classList.remove('Heroes--loading')
  }, 1200)
}
